// [목적] 강원캔버스 그림자 토큰 (design_structure §3-4)
// [이유] CLAUDE.md §6-3 — shadow 직접 입력 금지, 본 토큰만 사용
// [사이드 이팩트] MUI 테마 shadows 매핑 / Card hover / Modal 그림자
// [수정 시 고려사항] rgba 값은 color.text.high(#14181F) 기반 — 컬러 토큰 변경 시 재계산 필요

export const shadow = {
  card: '0 1px 2px rgba(20, 24, 31, 0.06), 0 4px 12px rgba(20, 24, 31, 0.04)',
  modal: '0 12px 32px rgba(20, 24, 31, 0.18)',
} as const;

export type ShadowTokens = typeof shadow;
export type ShadowKey = keyof typeof shadow;
